module.exports = __webpack_public_path__ + "static/media/home.31fac09a.png";